import { Directive, Renderer2, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'img[eiq-media-broken], video[eiq-media-broken]'
})
export class MediaBrokenDirective {
  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  @HostListener('error') onError(): void {
    this.renderer.setAttribute(this.el.nativeElement, 'src', './assets/images/broken-image.png');
  }
}
